// extracted by mini-css-extract-plugin
module.exports = {"toolboxBlocks":"Incident_toolboxBlocks__HBZF_","toolboxText":"Incident_toolboxText__24AGX","muiFixed":"Incident_muiFixed__2d_zl"};